import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell, Field, FormError } from "../components/AuthShell";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const [sp] = useSearchParams();
  const [f, setF] = useState({ username: sp.get("u") || "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/register", f);
      setUser(data);
      nav("/dashboard");
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="claim your name" subtitle="free forever. upgrades are lifetime." footer={<>have an account? <Link to="/login" className="text-[#ff3b91] hover:underline" data-testid="register-login-link">log in</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <label className="block">
          <span className="eyebrow mb-2 block">username</span>
          <div className="field flex items-center gap-1 p-0 pl-4 focus-within:border-[#ff3b91]">
            <span className="font-mono text-sm text-zinc-500">visc.lol/</span>
            <input data-testid="register-username-input" className="min-w-0 flex-1 bg-transparent py-2.5 pr-4 font-mono text-sm outline-none" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value.toLowerCase().replace(/[^a-z0-9_.]/g, "") })} maxLength={20} required />
          </div>
        </label>
        <Field label="email" type="email" data-testid="register-email-input" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required autoComplete="email" />
        <Field label="password" type="password" data-testid="register-password-input" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} minLength={8} required autoComplete="new-password" placeholder="8+ characters" />
        <FormError msg={err} />
        <button disabled={busy} className="btn-pink w-full" data-testid="register-submit-button">{busy ? "creating…" : "create account"}</button>
      </form>
    </AuthShell>
  );
}
